<template>
    <div class="container" v-if="showTable" id="table">
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered"
               style="font-size:0.8em;">
            <tbody>

            <tr v-if="pagination.data.length<=0" class="table-light">
                <th>{{$lang('Brak zmian.')}}</th>
            </tr>

            <template v-else v-for="change in pagination.data">
                <tr class="thead-dark">
                    <th colspan="1" :data-title="$lang('Data zmiany')">
                        <b>{{$lang('Data zmiany: ') + change.created_at_showable}}</b>
                    </th>
                    <th colspan="1" :data-title="$lang('Typ zmiany')">
                        <b>{{'(' + change.update_type + ')'}}</b>
                    </th>
                    <th colspan="1" :data-title="$lang('ID zgłoszenia')">
                        <b>
                            {{$lang('Dotyczy zgłoszenia: ')}}
                            <a :href="task_show_route+'/'+change.task_id" class="text-white">
                                {{change.task_id}}
                            </a>
                        </b>
                    </th>
                </tr>

                <tr class="d-none d-md-table-row">
                    <th class="central-record" style="width: 20%" scope="col">{{$lang('Zmieniony parametr')}}</th>
                    <th class="central-record" style="width: 40%" scope="col">{{$lang('Stara wartość')}}</th>
                    <th class="central-record" style="width: 40%" scope="col">{{$lang('Nowa wartość')}}</th>
                </tr>
                <tr v-for="(value, key) in change.new_values">
                    <td :data-title="$lang('Zmieniony parametr')" class="central-record">{{key}}</td>

                    <td v-if="key==='status'" :data-title="$lang('Stara wartość')" class="central-record">
                            <span style="width: 60%">
                                {{change.old_values[key].name}}
                            </span>
                    </td>
                    <td v-else :data-title="$lang('Stara wartość')" class="central-record">{{change.old_values[key]}}
                    </td>

                    <td v-if="key==='status'" :data-title="$lang('nowa wartość')" class="central-record">
                        <span style="width: 60%">{{change.new_values[key].name}}</span>
                    </td>
                    <td v-else :data-title="$lang('nowa wartość')" class="central-record">{{value}}</td>
                </tr>

                <template v-if="change.new_comments.length > 0">
                    <tr>
                        <th class="central-record" style="text-align: center" colspan="3">{{$lang('Nowe komentarze')}}
                        </th>
                    </tr>
                    <tr class="d-none d-md-table-row">
                        <th style="width: 10%">{{$lang('Autor')}}</th>
                        <th style="width: 10%">{{$lang('Data')}}</th>
                        <th style="width: 80%">{{$lang('Treść')}}</th>
                    </tr>
                    <tr v-for="comment in change.new_comments">
                        <td :data-title="$lang('Autor')" class="central-record">{{comment.author}}</td>
                        <td :data-title="$lang('Data')" class="central-record">{{comment.time}}</td>
                        <td :data-title="$lang('Treść')" style="text-align: justify">{{comment.content}}</td>
                    </tr>
                </template>
            </template>

            </tbody>
        </table>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <div class="col-12 row my-3 mx-0 px-0">
            <button @click="generate(1)" class="btn btn-primary" type="button">{{ $lang('Odśwież') }}</button>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../mixins/event-bus";

    export default {
        name: "integration-history-table",
        props: {
            get_changes_route: String,
            task_show_route: String,
            project_id: Number
        },
        data() {
            return {
                pagination: [],
                showTable: false
            }
        },
        methods: {
            setEventBusListenerPages() {
                EventBus.$on('changePage', ({value}) => {
                    this.generate(value);
                    document.getElementById('table').scrollIntoView();
                });
            },
            generate(page) {
                let self = this;
                axios.get(this.get_changes_route, {
                    project_id: self.project_id,
                    params: {
                        page: page
                    }
                })
                    .then(function (response) {
                        self.pagination = response.data;
                        self.showTable = true;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        created() {
            this.setEventBusListenerPages();
            this.generate(1)
        }
    }
</script>
